import { Fragment, useState } from 'react'
import Flatpickr from 'react-flatpickr'
import { Indonesian } from 'flatpickr/dist/l10n/id'
import 'flatpickr/dist/themes/light.css'

/*
  Tanggal ditampilkan "DD MMMM YYYY" (mis. 23 September 2026) dengan nama bulan Indonesia.
  Nilai yang dikirim ke parent tetap "YYYY-MM-DD", sama seperti input type="date" sebelumnya.
*/
const InputGroupDate = (props) => {
  const type = props.type
  const isLabel = props.label ? true : false
  // react-flatpickr membuat ulang date picker setiap render, jadi tanggal terpilih harus
  // selalu dikirim lewat `value` supaya tidak hilang setelah parent menyimpan tanggalnya
  const [selected, setSelected] = useState('')

  const changeHandler = (selectedDates, dateStr) => {
    const value = dateStr || null
    setSelected(dateStr || '')

    switch (type) {
      case 'startDate':
        props.setStartDate(value)
        break
      case 'endDate':
        props.setEndDate(value)
        break
      default:
        break
    }
  }

  return (
    <Fragment>
      {isLabel && <h5 className="card-title">{props.label}</h5>}
      <div className="wd-200 mg-b-30">
        <div className="input-group">
          <div className="input-group-text">
            <i className="fa fa-calendar text-light tx-16 lh-0 op-6" />
          </div>
          <Flatpickr
            className="form-control"
            placeholder="Pilih tanggal"
            value={selected}
            // Objek baru tiap render: react-flatpickr menambahkan handler ke dalam options,
            // jadi objek ini tidak boleh dipakai bersama antar instance
            options={{
              dateFormat: 'Y-m-d',
              altInput: true,
              altFormat: 'd F Y',
              altInputClass: 'form-control',
              locale: Indonesian,
            }}
            onChange={changeHandler}
          />
        </div>
      </div>
    </Fragment>
  )
}

export default InputGroupDate
